import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const ApiKeyTokenDialogStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "api-key-token-dialog-styled",
})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding-block: 8px;

  .api-key-token-dialog__token {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid ${greyMui._300};
    border-radius: 6px;
    background-color: ${greyMui._50};
    color: ${greyMui._900};
    font-family: monospace;
    font-size: 13px;
    word-break: break-all;
    user-select: all;
    /* a key is Latin characters; keep it readable left to right in Hebrew too */
    direction: ltr /* @noflip */;
    text-align: left /* @noflip */;
  }

  .api-key-token-dialog__usage {
    margin: 0;
    color: ${greyMui._700};
    font-size: 13px;
  }
`;
